import { NgModule } from 'ng-metadata/core';
import {PrmBlankIll} from './blankIll.directive';
import {BlankIllService} from './blankIll.service';
import {OpacRequestModule} from '../search/fullView/getit/opac/request/opacRequest.module'


@NgModule({
    declarations: [
        PrmBlankIll
    ],
    providers: [
        BlankIllService
    ],
    imports:[
        OpacRequestModule
    ]
})
export class BlankIllModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/blankIll/blankIll.module.ts